/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Typography,
    Divider,
    Grid,
    Box
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Layout from "../../../components/layout/Layout";
import InputText from "../../../components/form/InputText";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton"
import validator from "./validator"

import { getTransportSupplierId } from "../../../store/masters/thunk/transportSupplier/getId"
import { postTransportSupplier } from "../../../store/masters/thunk/transportSupplier/post"
import { putTransportSupplier } from "../../../store/masters/thunk/transportSupplier/put"

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("transportSupplier");
    const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

    const current = useSelector(state => state.masters.transportSupplier.detail);
    const put = useSelector(state => state.masters.transportSupplier.put);
    const post = useSelector(state => state.masters.transportSupplier.post);

    //  --------- Delete -------------

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); setTimeout(() => { "/config/transportSupplier/" }, 3000); }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
        if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); setTimeout(() => { "/config/transportSupplier/" }, 3000); }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    }, [put, post])

    useEffect(() => {
        if (!!id) {
            dispatch(getTransportSupplierId({ id }))
        }
    }, [dispatch, id])

    const onSubmit = (values) => {
        const idTransportSupplier = id;
        if (idTransportSupplier) { dispatch(putTransportSupplier({ idTransportSupplier, ...values })) }
        else { dispatch(postTransportSupplier(values)) }
    }

    const initialValues = {
        description: id ? get(current, "data.description", "") : "",
    }

    return (
        <Layout
            propsToolbar={{
                title: !id ? __(`head.new.name`) : __(`head.edit.name`),
                srute: !id ? __(`head.new.code`) : id
            }}
        >
            {get(current, "isLoading")
                ? (
                    <Skeleton />
                ) : (
                    <Formik initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                        {formik => (
                            <form onSubmit={get(formik, "handleSubmit")}>
                                <Paper className='p-4'>
                                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                                        <LoadingButton className='w-[100px] min-w-[100px]' variant="contained" color="secondary" type="submit" loading={get(post, "isLoading") || get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                        <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/config/transportSupplier")} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                    </Stack>
                                </Paper>

                                <Paper className='mt-4'>
                                    <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                        <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                    </Stack>
                                    <Divider />
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12}>
                                                <InputText
                                                    formik={formik}
                                                    name="description"
                                                    label={__(`form.description.label`)}
                                                    placeholder={__(`form.description.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    multiline
                                                    rows={3}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </form>
                        )}
                    </Formik>
                )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit